var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCount2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 29.2L23.64 24.36C24.1067 23.88 24.5 23.4667 24.82 23.12C25.14 22.76 25.38 22.4133 25.54 22.08C25.7133 21.7467 25.8 21.38 25.8 20.98C25.8 20.2467 25.62 19.7267 25.26 19.42C24.9133 19.1133 24.4133 18.96 23.76 18.96C23.0533 18.96 22.54 19.1267 22.22 19.46C21.9133 19.7933 21.7333 20.34 21.68 21.1H19.02C19.02 20.22 19.22 19.4467 19.62 18.78C20.02 18.1133 20.58 17.5933 21.3 17.22C22.02 16.8467 22.86 16.66 23.82 16.66C24.7533 16.66 25.5667 16.84 26.26 17.2C26.9667 17.56 27.5133 18.0667 27.9 18.72C28.3 19.36 28.5 20.1133 28.5 20.98C28.5 21.5533 28.3933 22.0933 28.18 22.6C27.9667 23.0933 27.6267 23.62 27.16 24.18C26.6933 24.74 26.0733 25.4067 25.3 26.18L21.98 29.5L21.7 28.7H28.66V31H18.92L18.9 29.2Z",
    fill: "#8CCE34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3552 37.8593C29.1558 39.794 25.391 40.5765 21.6856 40.0769C17.9802 39.5772 14.5571 37.8256 11.9844 35.1126C9.41164 32.3996 7.84397 28.8884 7.54155 25.1618C7.23913 21.4351 8.22015 17.7171 10.3218 14.6248C12.4234 11.5325 15.5193 9.25181 19.0957 8.16129C22.672 7.07077 26.5137 7.23598 29.9832 8.6295C33.4527 10.023 36.3414 12.5611 38.1698 15.8224C39.9982 19.0837 40.6564 22.8722 40.0351 26.5591",
    stroke: "#8CCE34",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7861 21.9044L40.2854 28.1144L33.6267 23.8286",
    stroke: "#8ECE30",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCount2);
export default __webpack_public_path__ + "static/media/count-2.95e9abe393a764baf72aa2217e642b73.svg";
export { ForwardRef as ReactComponent };